import React, { useState, useEffect } from "react";
import {
  Button, Container, Typography, Alert,
  Grid, TextField, Box, IconButton, Tooltip, Select, MenuItem, List, ListItem, ListItemText,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip,
  FormControl, InputLabel, Card, CardContent, Snackbar, Badge, Autocomplete,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Switch,
} from "@mui/material";
import {
  Event, Email, AccessTime, CheckCircleOutline, Pending, Cancel, Delete, Print, InfoOutlined,
  Map, Timer, Description, Note, CalendarMonth, People, Info, Visibility, Add, Upload,
  Download, AddCircleOutline, SystemUpdateAlt, DeleteOutline, Badgeicon, EmojiPeople, AddCircle, RemoveCircle,
} from "@mui/icons-material";
import { DatePicker, TimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import 'dayjs/locale/it';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import { Icon } from 'leaflet';
import { keyframes } from '@emotion/react';
import axios from 'axios';
import utils from '../../utils';
import { PieChart, Pie, Cell, Tooltip as RechartsTooltip, ResponsiveContainer } from 'recharts';
import JSZip from 'jszip';

const lampeggioVerde = keyframes`
  0% { box-shadow: 0 0 0px 0 rgba(0, 255, 0, 0.5); }
  50% { box-shadow: 0 0 10px 4px rgba(0, 255, 0, 0.6); }
  100% { box-shadow: 0 0 0px 0 rgba(0, 255, 0, 0.5); }
`;

const ts2Time = ms => {
  if (!ms) {
    return "";
  }
  return new Date(ms).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false, // Usa il formato 24 ore
  });
}

const getMarkers = timbratura => {
  if (!timbratura) {
    return [];
  }
  const markers = [{ title: 'Entrata', ...timbratura.entrata.c }];
  if (timbratura.uscita) {
    markers.push({ title: 'Uscita', ...timbratura.uscita.c });
  }
  for (let i = 0; i < timbratura.pause.length; i++) {
    markers.push({ title: `Pausa ${i + 1}`, ...timbratura.pause[i].da.c });
    if (timbratura.pause[i].a) {
      markers.push({ title: `Rientro ${i + 1}`, ...timbratura.pause[i].a.c });
    }
  }
  return markers.filter(m => m.lat && m.lon);
}

const dummyTimbratura = { entrata: {}, uscita: {}, pause: [] };

const TUTTI_DIP = { id: 0, cognome: 'Tutti i dipendenti', nome: '', orario: { giorni: [], tolleranze: { ordinario: 5, straordinario: 5 }, note: "", auto: false } }

const AreaDipTimbrature = ({ op }) => {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedEmployee, setSelectedEmployee] = useState(TUTTI_DIP);
  const [employees, setEmployees] = useState([TUTTI_DIP]);
  const [timbrature, setTimbrature] = useState({});
  const [dialogs, setDialogs] = useState({ roundHours: false, approveHours: false, map: false, notes: false, events: false, setHours: false, pauseDetails: false, eventDialog: false, communicationDialog: false, timbratureDialog: false, addEventDialog: false, addCommunicationDialog: false, addTimbraturaDialog: false, toleranceInfo: false, });
  const [editingTimbratura, setEditingTimbratura] = useState(null);
  const [editingPauseIndex, setEditingPauseIndex] = useState(null);
  const [savedIcons, setSavedIcons] = useState({ setHours: false, roundHours: false, approveHours: false });
  const [eventHistory, setEventHistory] = useState([]);
  const [communicationHistory, setCommunicationHistory] = useState([]);
  const [timbratureHistory, setTimbratureHistory] = useState([]);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [newEventData, setNewEventData] = useState({});
  const [newCommunicationData, setNewCommunicationData] = useState({});
  const [newTimbraturaData, setNewTimbraturaData] = useState({});

  const [calendarDialog, setCalendarDialog] = useState(false);
  const [eventDetailDialogOpen, setEventDetailDialogOpen] = useState(false);
  const [selectedDayEvents, setSelectedDayEvents] = useState([]);

  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [addTemplateDialogOpen, setAddTemplateDialogOpen] = useState(false);
  const [newTemplateTitle, setNewTemplateTitle] = useState('');

  const [aziende, setAziende] = useState([]);
  const [selectedAzienda, setSelectedAzienda] = useState(null);

  const [disabledEventi, setDisabledEventi] = useState(true);

  // Pie aziende timbratore attivo e non
  const [aziendeDialogOpen, setAziendeDialogOpen] = useState(false);
  const [selectedAziendeType, setSelectedAziendeType] = useState(null);
  const aziendeWithTimbratore = aziende.filter(a => a.timbratore).length;
  const aziendeWithoutTimbratore = aziende.length - aziendeWithTimbratore;

  // Mail ricorrenti presenze dialog state
  const [mailDialogOpen, setMailDialogOpen] = useState(false);
  const [mailEnabled, setMailEnabled] = useState(false);
  const [mailRecipient, setMailRecipient] = useState('');
  const [mailDate, setMailDate] = useState(dayjs().startOf('month'));

  const pieData = [
    { name: 'Attivo', value: aziendeWithTimbratore },
    { name: 'Non attivo', value: aziendeWithoutTimbratore }
  ];

  const pieColors = ['#4caf50', '#f44336'];

  const handlePieClick = (data, index) => {
    setSelectedAziendeType(data.name);
    setAziendeDialogOpen(true);
  };

  const navigate = useNavigate();

  // Dialog Di Conferma Button Salva per Tutti
  const [confirmSaveDialogOpen, setConfirmSaveDialogOpen] = useState(false);

  useEffect(() => {
    if (!op) {
      loadDipendenti();
      loadTemplates();
      loadUser();
    } else {
      loadAziende();
    }
  }, []);

  useEffect(() => {
    if (!op || selectedAzienda) {
      loadTimbrature(selectedEmployee.id, selectedMonth, selectedYear);
    }
  }, [selectedEmployee.id, selectedAzienda, selectedMonth, selectedYear]);

  useEffect(() => {
    if (selectedAzienda) {
      loadDipendenti(selectedAzienda);
      loadTemplates(selectedAzienda);
      loadUser(selectedAzienda);
    }
  }, [selectedAzienda]);

  const handleNewEventChange = (field, value) => {
    setNewEventData((prev) => ({ ...prev, [field]: value }));
  };

  const handleNewCommunicationChange = (field, value) => {
    setNewCommunicationData((prev) => ({ ...prev, [field]: value }));
  };

  const handleNewTimbraturaChange = (field, value) => {
    setNewTimbraturaData((prev) => ({ ...prev, [field]: value }));
  };

  const loadDipendenti = async (userId = "") => {
    try {
      const res = await axios.get('/api/dipendenti?id=' + userId, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setEmployees([TUTTI_DIP, ...res.data.dipendenti]);
        if (selectedEmployee.id) {
          // aggiorna il dipendente selezionato
          setSelectedEmployee(res.data.dipendenti.filter(dip => dip.id == selectedEmployee.id)[0]);
        }
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  };

  const loadTemplates = async (userId = "") => {
    try {
      const res = await axios.get('/api/gettemplateorari?id=' + userId, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setTemplates(res.data.templates);
        setSelectedTemplate('');
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  };

  const loadUser = async (userId) => {
    try {
      const res = await axios.get(op ? `/api/getuser?id=${userId}` : '/api/me', {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        const d = res.data;
        setMailDate(dayjs().date((op ? d.user : d.me).mail_timbrature_info.date || 1));
        setMailRecipient((op ? d.user : d.me).mail_timbrature_info.email || '');
        setMailEnabled((op ? d.user : d.me).mail_timbrature_info.enabled || false);
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  };

  const handleSaveEmailRicorrente = async () => {
    try {
      const res = await axios.post('/api/saveemailricorrente',
        { email: mailRecipient, date: mailDate.date(), enabled: mailEnabled, id: selectedAzienda }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setSuccessMessage("Email ricorrente aggiornata con successo");
        setMailDialogOpen(false);
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  };

  const handleSaveTemplate = async () => {
    try {
      const res = await axios.post('/api/createtemplateorario',
        { payload: selectedEmployee.orario, name: newTemplateTitle, userId: selectedAzienda }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setSuccessMessage("Template aggiornato con successo");
        setAddTemplateDialogOpen(false);
        setNewTemplateTitle('');
        loadTemplates(selectedAzienda);
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  };

  const handleUpdateTemplate = async () => {
    try {
      const res = await axios.post('/api/updatetemplateorario',
        { id: selectedTemplate, payload: selectedEmployee.orario, userId: selectedAzienda }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setSuccessMessage("Template aggiornato con successo");
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  }

  const handleDeleteTemplate = async () => {
    try {
      const res = await axios.post('/api/deletetemplateorario',
        { id: selectedTemplate, userId: selectedAzienda }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setSuccessMessage("Template eliminato con successo");
        loadTemplates(selectedAzienda);
        setSelectedTemplate('');
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  }

  // se id = 0 carica quelli di tutti filtrati
  const loadTimbrature = async (id, mese, anno) => {
    try {
      const res = await axios.get('/api/timbrature', {
        headers: utils.getAuthHeaders(), params: { id, mese, anno, userId: selectedAzienda }
      });
      const { success, error } = res.data;
      if (success) {
        setTimbrature(res.data.timbrature);
        setTimbratureHistory(res.data.richiesteTimbrature);
        setEventHistory(res.data.eventi);
        setCommunicationHistory(res.data.comunicazioni);
        setDisabledEventi(res.data.disabledEventi);
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  };

  const loadAziende = async () => {
    try {
      const res = await axios.get(`/api/aziendeeop`, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error, aziende } = res.data;
      if (success) {
        setAziende(aziende);
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  };

  const saveOrario = async (tutti = false) => {
    try {
      const res = await axios.post('/api/updateprofiloorario', { ...selectedEmployee, tutti, userId: selectedAzienda }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        loadDipendenti(selectedAzienda);
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
    setConfirmSaveDialogOpen(false);
    handleDialog("setHours", false);
  };

  const saveEditingTimbratura = async () => {
    try {
      const res = await axios.post('/api/updatetimbratura', { timbratura: editingTimbratura, id: selectedEmployee.id, userId: selectedAzienda }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        loadTimbrature(selectedEmployee.id, selectedMonth, selectedYear);
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
    handleDialog("entrataMod", false);
    handleDialog("uscitaMod", false);
    handleDialog("pauseStartMod", false);
    handleDialog("pauseEndMod", false);
    handleDialog("pauseDetails", false);
    handleDialog("notes", false);
  };

  const handleTimbraturaApproval = async (dipId, id, approve) => {
    try {
      const res = await axios.post('/api/approvetimbratura', { timbratura: id, approve, id: dipId, userId: selectedAzienda }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        loadTimbrature(selectedEmployee.id, selectedMonth, selectedYear);
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  };

  const handleEventApproval = async (id, approve) => {
    try {
      const res = await axios.post('/api/approveevento', { id, approve, userId: selectedAzienda }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        loadTimbrature(selectedEmployee.id, selectedMonth, selectedYear);
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  };

  const handleSaveNewTimbraturaRequest = async () => {
    if (!selectedEmployee || !selectedEmployee.id) {
      setError(`Per favore, seleziona un dipendente prima di aggiungere una timbratura.`);
      return;
    }

    const { date, entrata, uscita, pauses = [], rientri = [], note } = newTimbraturaData;

    if (!date || !entrata || !uscita) {
      setError(`Inserire la data e gli orari di entrata e uscita.`);
      return;
    }

    const giorno = new Date(`${date.$y}-${(date.$M + 1).toString().padStart(2, '0')}-${date.$D.toString().padStart(2, '0')}T12:00:00`);

    const payload = { note };

    let entrataDate = entrata.$d;
    entrataDate.setFullYear(giorno.getFullYear());
    entrataDate.setMonth(giorno.getMonth());
    entrataDate.setDate(giorno.getDate());
    payload.entrata = { t: entrataDate.getTime() };

    let uscitaDate = uscita.$d;
    uscitaDate.setFullYear(giorno.getFullYear());
    uscitaDate.setMonth(giorno.getMonth());
    uscitaDate.setDate(giorno.getDate());
    if (uscitaDate.getTime() <= payload.entrata.t) {
      uscitaDate.setDate(uscitaDate.getDate() + 1);
    }
    payload.uscita = { t: uscitaDate.getTime() };

    payload.pause = [];
    for (let i = 0; i < pauses.length; i++) {
      const p = pauses[i]?.$d;
      const r = rientri[i]?.$d;
      if (p && r) {
        p.setFullYear(giorno.getFullYear());
        p.setMonth(giorno.getMonth());
        p.setDate(giorno.getDate());
        if (p.getTime() <= payload.entrata.t) {
          p.setDate(p.getDate() + 1);
        }
        r.setFullYear(giorno.getFullYear());
        r.setMonth(giorno.getMonth());
        r.setDate(giorno.getDate());
        if (r.getTime() <= payload.entrata.t) {
          r.setDate(r.getDate() + 1);
        }
        payload.pause.push({ da: { t: p.getTime() }, a: { t: r.getTime() } });
      }
    }

    try {
      const res = await axios.post(`/api/richiedidiptimbraturecli`, {
        giorno: giorno.toISOString().substring(0, 10),
        payload,
        id: selectedEmployee.id,
        userId: selectedAzienda
      }, {
        headers: utils.getAuthHeaders()
      });

      const { success, error } = res.data;
      if (success) {
        setNewTimbraturaData({});
        setSuccessMessage("Richiesta di timbratura inviata con successo!");
        loadTimbrature(selectedEmployee.id, selectedMonth, selectedYear);
        handleDialog("addTimbraturaDialog", false);
      } else {
        setError(`ERRORE: ${error}`);
      }
    } catch (err) {
      console.log(err);
      setError("ERRORE: Si è verificato un errore imprevisto sul nostro server.");
    }
  };

  const handleSaveNewRequest = async (requestType) => {
    const isEvent = requestType === 'event';
    const data = isEvent ? newEventData : newCommunicationData;
    const endpoint = isEvent ? '/api/richiedidipeventcli' : '/api/richiedidipcommunicationcli';
    const setData = isEvent ? setNewEventData : setNewCommunicationData;
    const dialogName = isEvent ? 'addEventDialog' : 'addCommunicationDialog';
    const requestName = isEvent ? 'evento' : 'comunicazione';

    if (!selectedEmployee || !selectedEmployee.id) {
      setError(`Per favore, seleziona un dipendente prima di aggiungere un ${requestName}.`);
      return;
    }

    if (!data.type) {
      setError(`Selezionare il tipo di ${requestName}.`);
      return;
    }
    if (!data.dateFrom || !data.dateTo) {
      setError(`Inserire data inizio e fine`);
      return;
    }
    if (data.dateFrom.$d > data.dateTo.$d) {
      setError(`La data di fine deve essere uguale o maggiore della data di inizio`);
      return;
    }

    const d = data.dateFrom;
    const giorno = new Date(`${d.$y}-${(d.$M + 1).toString().padStart(2, '0')}-${d.$D.toString().padStart(2, '0')}T12:00:00`);

    const payload = { note: data.note, type: data.type };
    payload.dateFrom = `${d.$y}-${(d.$M + 1).toString().padStart(2, '0')}-${d.$D.toString().padStart(2, '0')}`;

    const dTo = data.dateTo;
    const giornoTo = new Date(`${dTo.$y}-${(dTo.$M + 1).toString().padStart(2, '0')}-${dTo.$D.toString().padStart(2, '0')}T12:00:00`);
    payload.dateTo = `${dTo.$y}-${(dTo.$M + 1).toString().padStart(2, '0')}-${dTo.$D.toString().padStart(2, '0')}`;

    if (data.timeFrom && data.timeTo) {
      let timeFromD = data.timeFrom.$d;
      timeFromD.setFullYear(giorno.getFullYear());
      timeFromD.setMonth(giorno.getMonth());
      timeFromD.setDate(giorno.getDate());
      payload.timeFrom = timeFromD.getTime();

      let timeToD = data.timeTo.$d;
      timeToD.setFullYear(giornoTo.getFullYear());
      timeToD.setMonth(giornoTo.getMonth());
      timeToD.setDate(giornoTo.getDate());
      payload.timeTo = timeToD.getTime();

      if (payload.dateFrom === payload.dateTo && payload.timeFrom > payload.timeTo) {
        setError(`L'ora di fine deve essere uguale o maggiore dell'ora di inizio per gli eventi di un giorno`);
        return;
      }
    }

    try {
      let file;
      const json = {
        giorno: giorno.toISOString().substring(0, 10),
        payload,
        tipo: payload.type,
        id: selectedEmployee.id,
        userId: selectedAzienda
      };

      if (data.files && data.files.length > 0) {
        if (data.files.length === 1) {
          file = data.files[0];
          json.file = data.files[0].name;
        } else {
          const zip = new JSZip();
          for (let i = 0; i < data.files.length; i++) {
            const f = data.files[i];
            zip.file(f.name, f);
          }
          file = await zip.generateAsync({ type: 'blob' });
          json.file = 'files.zip';
        }
      }

      const form = new FormData();
      if (file) {
        form.append("file", file);
      }
      form.append("data", JSON.stringify(json));

      const res = await axios.post(endpoint, form, {
        headers: {
          ...utils.getAuthHeaders(),
          "Content-Type": "multipart/form-data",
        }
      });

      const { success, error } = res.data;
      if (success) {
        setData({});
        setSuccessMessage(`Richiesta ${requestName} inviata con successo!`);
        loadTimbrature(selectedEmployee.id, selectedMonth, selectedYear);
        handleDialog(dialogName, false);
      } else {
        setError(`ERRORE: ${error}`);
      }
    } catch (err) {
      console.log(err);
      setError("ERRORE: Si è verificato un errore imprevisto sul nostro server.");
    }
  };


  const approvaOre = async () => {
    try {
      const res = await axios.post('/api/autocompilapresenze',
        { anno: selectedYear, mese: selectedMonth, userId: selectedAzienda }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setSuccessMessage("Presenze compilate con successo!");
      } else {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  };

  const calcolaSommaOreGiorni = eventi => {
    let giorni = 0;
    let minuti = 0;
    const primoDelMese = `${selectedYear}-${(Number(selectedMonth) + 1).toString().padStart(2, '0')}-01`;
    const ultimoDelMese = `${selectedYear}-${(Number(selectedMonth) + 1).toString().padStart(2, '0')}-31`;
    for (const evento of eventi) {
      const dip = employees.filter(e => e.id == evento.dipendente_id)[0];
      if (!dip) {
        continue;
      }
      if (evento.payload.dateFrom == evento.payload.dateTo && evento.payload.timeFrom && evento.payload.timeTo) {
        if (new Date(evento.payload.dateFrom).getMonth() == selectedMonth && new Date(evento.payload.dateFrom).getFullYear() == selectedYear) {
          minuti += (evento.payload.timeTo - evento.payload.timeFrom) / (60 * 1000);
        }
      } else if (evento.payload.dateFrom && evento.payload.dateTo) {
        let currentDate = evento.payload.dateFrom;
        if (currentDate < primoDelMese) {
          currentDate = primoDelMese;
        }
        while (currentDate <= evento.payload.dateTo && currentDate <= ultimoDelMese) {
          let giornoDellaSettimana = new Date(currentDate).getDay();
          giornoDellaSettimana = giornoDellaSettimana - 1;
          if (giornoDellaSettimana == -1) {
            giornoDellaSettimana = 6;
          }
          const ore = dip.orario.giorni[giornoDellaSettimana];
          const cd = new Date(currentDate);
          const isFestivo = getFestivoInfo(cd.getFullYear(), cd.getMonth(), cd.getDate());
          if (ore != '0:00' && ore != '00:00' && !isFestivo) {
            giorni += 1;
          }
          currentDate = `${currentDate.substring(0, 8)}${(Number(currentDate.substring(8)) + 1).toString().padStart(2, '0')}`;
        }
      }
    }
    if (!giorni && !minuti) {
      return "-";
    }
    if (!giorni) {
      return utils.min2hours(minuti) + " ore";
    }
    if (!minuti) {
      return `${giorni} giorni`;
    }
    return `${giorni} giorni e ${utils.min2hours(minuti)} ore`;
  }

  const handleCommViewed = async () => {
    if (op) {
      return; // op non toglie la notifica alle aziende
    }
    try {
      const ids = communicationHistory.map(c => Number(c.id));
      const res = await axios.post('/api/setcomunicazionevisualizzata', { ids }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (!success) {
        setError(error);
      }
    } catch (error) {
      setError(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  };

  const handleConfirmSaveOpen = () => {
    setConfirmSaveDialogOpen(true);
  };

  const handleConfirmSaveClose = () => {
    setConfirmSaveDialogOpen(false);
  };

  // Conferma Approva Ore
  const [confirmApproveDialogOpen, setConfirmApproveDialogOpen] = useState(false);
  const handleConfirmApproveOpen = () => {
    setConfirmApproveDialogOpen(true);
  };

  const handleConfirmApproveClose = () => {
    setConfirmApproveDialogOpen(false);
  };

  const handleConfirmApprove = () => {
    approvaOre();
    setConfirmApproveDialogOpen(false);
  };

  // Giorni Festivi nella tabella
  const getFestivoInfo = (anno, mese, giorno) => {
    const festivi = [
      { mese: 0, giorno: 1, nome: 'Capodanno' },
      { mese: 0, giorno: 6, nome: 'Epifania' },
      { mese: 3, giorno: 25, nome: 'Festa della Liberazione' },
      { mese: 4, giorno: 1, nome: 'Festa del Lavoro' },
      { mese: 5, giorno: 2, nome: 'Festa della Repubblica' },
      { mese: 7, giorno: 15, nome: 'Ferragosto' },
      { mese: 10, giorno: 1, nome: 'Ognissanti' },
      { mese: 11, giorno: 8, nome: 'Immacolata Concezione' },
      { mese: 11, giorno: 25, nome: 'Natale' },
      { mese: 11, giorno: 26, nome: 'Santo Stefano' },
    ];

    return festivi.find(festivo => festivo.mese === mese && festivo.giorno === giorno);
  };

  const handleDialog = (type, open) => {
    setDialogs((prev) => ({ ...prev, [type]: open }));
  };

  const updateTimbrature = (updateFn) => {
    setTimbrature((prevTimbrature) => prevTimbrature.map(updateFn));
  };

  const handleSave = (type) => {
    switch (type) {
      case "setHours":
        saveOrario();
        break;
      case "addEventDialog":
        handleSaveNewRequest('event');
        break;
      case "addCommunicationDialog":
        handleSaveNewRequest('communication');
        break;
      case "roundHours":
        updateTimbrature((timbratura) => ({
          ...timbratura,
          totaleOre: (Math.round(parseFloat(timbratura.totaleOre) * 60 / 15) * 15) / 60,
        }));
        handleDialog(type, false);
        break;
      case "entrataMod":
      case "uscitaMod":
      case "pauseStartMod":
      case "pauseEndMod":
        saveEditingTimbratura();
        break;
      case "notes":
        saveEditingTimbratura();
        break;
      default:
        break;
    }
    setEditingPauseIndex(null); // Reset l'indice della pausa dopo il salvataggio
  };

  const handleCalendarDialog = () => {
    setCalendarDialog(true);
  };

  // Evento sul Calendario
  const getEventsForDay = (day) => {
    const eventi = eventHistory.filter((event) => isEventHappeningAtDay(event, day)).map(event => {
      const dip = employees.filter(dip => dip.id == event.dipendente_id)[0];
      return { ...event, nome: `${dip.cognome} ${dip.nome}` };
    });
    const comunicazioni = communicationHistory.filter((event) => isEventHappeningAtDay(event, day)).map(event => {
      const dip = employees.filter(dip => dip.id == event.dipendente_id)[0];
      return { ...event, nome: `${dip.cognome} ${dip.nome}`, approvato: true };
    });
    return [...eventi, ...comunicazioni];
  };

  const isEventHappeningAtDay = (event, day) => {
    const dayString = `${day.getFullYear()}-${(day.getMonth() + 1).toString().padStart(2, '0')}-${day.getDate().toString().padStart(2, '0')}`;
    return event.payload.dateFrom <= dayString && event.payload.dateTo >= dayString;
  }

  // Colori per Dialog Calendario vari eventi
  const getEventColor = (event) => {
    const color = getColorByType(event.tipo);

    return event.approvato
      ? { backgroundColor: color, color: 'white' }
      : { backgroundColor: 'white', border: `2px solid ${color}`, color };
  };

  const getColorByType = (type) => {
    switch (type) {

      case 'Ferie': return '#28a745'; // Verde
      case 'Permesso': return '#007bff'; // Blu
      case 'Assenza': return '#17a2b8'; // Azzurro

      case 'Malattia': return '#dc3545'; // Rosso
      case 'Infortunio': return '#ff5733'; // Arancione scuro
      case 'Maternità': return '#ff85a2'; // Rosa
      case 'Congedo': return '#ff9f40'; // Arancione
      case 'Donazione Sangue': return '#c0392b'; // Rosso sangue

      // Altri tipi
      default: return '#6c757d'; // Grigio
    }
  };

  const eventColors = {
    'Ferie': '#28a745',
    'Permesso': '#007bff',
    'Assenza': '#17a2b8',
    'Malattia': '#dc3545',
    'Infortunio': '#ff5733',
    'Maternità': '#ff85a2',
    'Congedo': '#ff9f40',
    'Donazione': '#c0392b',
    'Altro': '#6c757d',
  };

  // Dialog del Calendario
  const renderCalendarDialog = () => {
    const firstDayOfMonth = new Date(selectedYear, selectedMonth, 1);
    const daysInPrevMonth = getDaysInMonth(selectedYear, selectedMonth - 1);
    const startDayOfWeek = firstDayOfMonth.getDay() === 0 ? 6 : firstDayOfMonth.getDay() - 1;
    const prevMonthDaysNeeded = startDayOfWeek;

    const prevMonthDays = Array.from({ length: prevMonthDaysNeeded }, (_, i) =>
      new Date(selectedYear, selectedMonth - 1, daysInPrevMonth.length - prevMonthDaysNeeded + i + 1)
    );

    const daysInNextMonth = getDaysInMonth(selectedYear, selectedMonth + 1);
    const lastDayOfMonth = daysInMonth[daysInMonth.length - 1];
    const endDayOfWeek = lastDayOfMonth.getDay() === 0 ? 6 : lastDayOfMonth.getDay() - 1;
    const nextMonthDaysNeeded = 6 - endDayOfWeek;

    const nextMonthDays = Array.from({ length: nextMonthDaysNeeded }, (_, i) =>
      new Date(selectedYear, selectedMonth + 1, i + 1)
    );

    const allDays = [...prevMonthDays, ...daysInMonth, ...nextMonthDays];

    const monthName = new Date(selectedYear, selectedMonth).toLocaleString('it-IT', { month: 'long' });

    return (
      <Dialog
        open={calendarDialog}
        onClose={() => setCalendarDialog(false)}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              Calendario di {monthName} {selectedYear}
            </Grid>
            <Grid item>
              <Grid container spacing={1}>
                {Object.entries(eventColors).map(([type, color]) => (
                  <Grid item key={type}>
                    <Typography variant="body2" style={{ display: 'flex', alignItems: 'center', fontSize: '0.65rem' }}>
                      <span style={{ backgroundColor: color, borderRadius: '50%', width: '10px', height: '10px', display: 'inline-block', marginRight: '5px' }}></span>
                      {type}
                    </Typography>
                  </Grid>
                ))}
                <Tooltip title="Stampa">
                  <IconButton
                    style={{ color: 'gray' }}
                    onClick={() => window.print()}
                  >
                    <Print fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {Array.from({ length: Math.ceil(allDays.length / 7) }, (_, weekIndex) => (
              <Grid container item xs={12} key={weekIndex} spacing={2} justifyContent="center">
                {allDays.slice(weekIndex * 7, (weekIndex + 1) * 7).map((day) => {
                  const isWeekend = day.getDay() === 0 || day.getDay() === 6;
                  const festivoInfo = getFestivoInfo(day.getFullYear(), day.getMonth(), day.getDate());
                  const isFestivo = !!festivoInfo;
                  const isPrevMonth = day.getMonth() !== selectedMonth && day.getMonth() === (selectedMonth - 1);
                  const isNextMonth = day.getMonth() !== selectedMonth && day.getMonth() === (selectedMonth + 1);

                  return (
                    <Grid item xs={12} sm={3} md={3} lg={1.7} key={day.toISOString()}>
                      <Card
                        sx={{
                          height: '150px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          backgroundColor: isPrevMonth || isNextMonth
                            ? 'rgba(211, 211, 211, 0.5)' // Light grey for previous or next month
                            : isWeekend
                              ? 'rgba(255, 255, 0, 0.19)'
                              : isFestivo
                                ? 'rgba(173, 216, 230, 0.21)'
                                : 'transparent',
                          opacity: isPrevMonth || isNextMonth ? 0.5 : 1,
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          const events = getEventsForDay(day);
                          setSelectedDayEvents(events);
                          setEventDetailDialogOpen(true);
                        }}
                      >
                        <CardContent>
                          {festivoInfo && (
                            <Typography variant="caption" color="textSecondary" style={{ fontStyle: 'italic', display: 'block', marginBottom: '4px' }}>
                              {festivoInfo.nome}
                            </Typography>
                          )}
                          <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic', display: 'block', marginBottom: '4px' }}>
                            {formatDate(day)}
                          </Typography>
                          {(() => {
                            const events = getEventsForDay(day);
                            const displayedEvents = events.slice(0, 3);
                            return (
                              <>
                                {displayedEvents.map((event, index) => (
                                  <Typography
                                    key={index}
                                    variant="caption"
                                    style={{
                                      borderRadius: '12px',
                                      padding: '2px 6px',
                                      display: 'block', // Mette gli eventi in colonna
                                      fontSize: '0.75rem',
                                      textAlign: 'center',
                                      margin: '3px',
                                      ...getEventColor(event),
                                    }}
                                  >
                                    {selectedEmployee.id ? event.tipo : event.nome}
                                  </Typography>
                                ))}
                                {events.length > 3 && (
                                  <Typography
                                    variant="caption"
                                    color="textSecondary"
                                    style={{
                                      fontStyle: 'italic',
                                      fontSize: "14px",
                                      textAlign: 'center', // Centrato
                                      fontWeight: 'bold',  // Più visibile
                                      display: 'block',
                                      marginTop: '1px',
                                    }}
                                  >
                                    ...
                                  </Typography>
                                )}
                              </>
                            );
                          })()}
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCalendarDialog(false)}>Chiudi</Button>
        </DialogActions>
      </Dialog>
    );
  };

  // Render di tutti i dialog Eventi Comunicazioni Timbrature ecc
  const renderDialog = (type, title, content, allowSave = true, maxWidth = 'lg') => {
    const isSmallDialog = [
      'entrataMod',
      'uscitaMod',
      'pauseStartMod',
      'pauseEndMod',
    ].includes(type);

    return (
      <Dialog
        open={dialogs[type]}
        onClose={() => { setEditingTimbratura(null); handleDialog(type, false) }}
        maxWidth={isSmallDialog ? 'sm' : maxWidth}
        fullWidth={!isSmallDialog}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Box mt={1}>
            {content}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setEditingTimbratura(null); handleDialog(type, false) }}>Chiudi</Button>
          {allowSave && <Button onClick={() => handleSave(type)} variant="contained" color="primary">Salva</Button>}
        </DialogActions>
      </Dialog>
    );
  };

  // Dialog dei dettagli degli eventi
  const renderEventDetailDialog = () => (
    <Dialog
      open={eventDetailDialogOpen}
      onClose={() => setEventDetailDialogOpen(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Dettagli</DialogTitle>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow
                style={{
                  backgroundColor: '#333', // Colore scuro per l'intestazione
                }}
              >
                <TableCell style={{ color: 'white', fontWeight: 'bold', borderTopLeftRadius: '8px' }}>Tipo</TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }}>Dipendente</TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }}>Data Da</TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }}>Data A</TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }}>Ora Da</TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }}>Ora A</TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold', borderTopRightRadius: '8px' }}>Note</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedDayEvents.map((event, index) => {

                const isCommunication = event.visualizzata !== undefined;

                return (
                  <TableRow key={index}>
                    <TableCell>
                      <Typography
                        variant="caption"
                        style={{
                          borderRadius: '12px',
                          padding: '2px 6px',
                          display: 'inline-block',
                          fontSize: '0.75rem',
                          textAlign: 'center',
                          ...getEventColor(event),
                        }}
                      >
                        {event.tipo}
                      </Typography>
                    </TableCell>
                    <TableCell>{event.nome}</TableCell>
                    <TableCell>{event.payload?.dateFrom ? utils.revDate(event.payload.dateFrom) : '-'}</TableCell>
                    <TableCell>{event.payload?.dateTo ? utils.revDate(event.payload.dateTo) : '-'}</TableCell>
                    <TableCell>{event.payload?.timeFrom ? ts2Time(event.payload.timeFrom) : '-'}</TableCell>
                    <TableCell>{event.payload?.timeTo ? ts2Time(event.payload.timeTo) : '-'}</TableCell>
                    <TableCell align="center">
                      <IconButton
                        disabled={!event.payload.note} onClick={() => {
                          setEditingTimbratura({ ...dummyTimbratura, ...event.payload });
                          handleDialog(isCommunication ? "notesCommunication" : "notesEvent", true)
                        }}
                      >
                        <Note fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setEventDetailDialogOpen(false)}>Chiudi</Button>
      </DialogActions>
    </Dialog>
  );

  const formatDate = (date) => {
    const options = { day: 'numeric', weekday: 'short' };
    const formattedDate = date.toLocaleDateString('it-IT', options).replace(/ /g, ' ');
    return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
  };

  const getDaysInMonth = (year, month) => {
    const date = new Date(year, month, 1);
    const days = [];
    while (date.getMonth() === month) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  };

  const getTimbratureForDay = (day) => {
    return timbrature[day.getDate()] || { entrata: {}, pause: [], uscita: {}, totMinStra: 0, totMinOrd: 0, note: "" };
  };

  const calculateTotalHours = () => {
    return Object.values(timbrature).reduce((total, timbratura) => total + (timbratura.totMinOrd || 0), 0);
  };

  const calculateTotalStraordinario = () => {
    return Object.values(timbrature).reduce((total, timbratura) => total + (timbratura.totMinStra || 0), 0);
  };

  const calculateTotalPauseForAllDays = () => {
    return Object.values(timbrature).reduce((total, timbratura) => total + calculateTotalPause(timbratura.pause), 0);
  };

  const calculateTotalPause = (pauseArray) => {
    if (!Array.isArray(pauseArray)) {
      return 0;
    }

    return Math.round(pauseArray.reduce((total, pausa) => {
      return total + ((pausa.a ? pausa.a.t : Date.now()) - pausa.da.t) / (1000 * 60); // Convert to minutes
    }, 0));
  };

  const daysInMonth = getDaysInMonth(selectedYear, selectedMonth);

  // Calcola Totale Ore Nel Dialog Profilo Orario
  const calculateWeeklyTotal = () => {
    let totalMinutes = selectedEmployee.orario.giorni.reduce((acc, day) => {
      if (day) {
        const hours = parseInt(day.split(':')[0], 10);
        const minutes = parseInt(day.split(':')[1], 10);
        return acc + (hours * 60) + minutes;
      }
      return acc;
    }, 0);

    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    return `${totalHours}.${remainingMinutes}`;
  };

  const handleAddTemplate = () => {
    setAddTemplateDialogOpen(true);
  };

  const handleCloseTemplateDialog = () => {
    setAddTemplateDialogOpen(false);
    setNewTemplateTitle('');
  };

  const handleTemplateChange = (templateId) => {
    const selected = templates.find(template => template.id === templateId);
    if (selected) {
      setSelectedEmployee(prevEmployee => ({
        ...prevEmployee,
        orario: selected.payload
      }));
    }
  };

  return (
    <Container maxWidth="xl">
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" mt={0} gap={1}>
          <Box display="flex" alignItems="center" gap={1}>

            <Box display="flex" flexDirection="column" alignItems="center" position="absolute" right={0} top={74} mr={1}>
              <Tooltip title="Invia Mail Ricorrente">
                <IconButton
                  style={{ color: mailEnabled ? 'green' : 'dodgerblue' }}
                  onClick={() => setMailDialogOpen(true)}
                >
                  <Email fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Stampa">
                <IconButton
                  style={{ color: 'gray' }}
                  onClick={() => window.print()}
                >
                  <Print fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>

            <Typography variant="h4">
              Area Timbrature
            </Typography>
            {op && aziende.length > 0 && !selectedAzienda && (
              <PieChart width={50} height={50}>
                <Pie
                  data={pieData}
                  cx={20}
                  cy={20}
                  innerRadius={6}
                  outerRadius={24}
                  dataKey="value"
                  onClick={handlePieClick}
                >
                  {pieData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={pieColors[index]} />
                  ))}
                </Pie>
                <RechartsTooltip
                  formatter={(value, name) => [`${value} aziende`, name]}
                />
              </PieChart>
            )}
            {!op && (
              <Tooltip title="Buste Paga">
                <IconButton
                  color="primary"
                  onClick={() => navigate(`../cli/bustepaga`)}
                >
                  <Description fontSize="large" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
          <Typography variant="subtitle1" style={{ color: 'grey', fontStyle: 'italic' }}>
            Impostare il profilo orario prima di eseguire operazioni sul timbratore.
          </Typography>
        </Box>

        {/* Dialog Mail Ricorrenti */}
        <Dialog open={mailDialogOpen} onClose={() => setMailDialogOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6">
                Invio Mail Ricorrente Presenze
              </Typography>
              <FormControlLabel
                control={
                  <Switch
                    checked={mailEnabled}
                    onChange={(e) => setMailEnabled(e.target.checked)}
                    color="primary"
                  />
                }
                label="Abilita"
                labelPlacement="start"
              />
            </Box>
          </DialogTitle>

          <DialogContent>
            <Typography
              variant="subtitle2"
              color="textSecondary"
              sx={{ fontStyle: 'italic', mb: 3 }}
            >
              Quando il servizio è abilitato, ogni mese verrà inviata automaticamente una mail con il PDF delle presenze del mese precente al destinatario indicato, nel giorno selezionato.
              Si ricorda di di controllare tutte le timbrature e successivamente effettuare la compilazione automatica delle presenze prima di tale data.
            </Typography>

            <Grid container direction="column" spacing={2}>
              <Grid item>
                <TextField
                  label="Mittente"
                  value="Studio Romeo"
                  disabled={true}
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              <Grid item>
                <TextField
                  label="Destinatario"
                  value={mailRecipient}
                  onChange={(e) => setMailRecipient(e.target.value)}
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              <Grid item>
                <DatePicker
                  label="Giorno del Mese"
                  value={mailDate}
                  onChange={(newValue) => setMailDate(newValue)}
                  views={['day']}
                  shouldDisableDate={(date) => date.date() > 20}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth variant="outlined" />
                  )}
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setMailDialogOpen(false)} color="primary">
              Annulla
            </Button>
            <Button
              onClick={() => handleSaveEmailRicorrente()}
              color="primary"
              variant="contained"
            >
              Salva
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog Pie Az Timbratore Attivo e non */}
        <Dialog
          open={aziendeDialogOpen}
          onClose={() => setAziendeDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>{`Aziende Timbratore ${selectedAziendeType}`}</DialogTitle>
          <DialogContent>
            <ol>
              {aziende
                .filter(azienda => selectedAziendeType === 'Attivo' ? azienda.timbratore : !azienda.timbratore)
                .map(azienda => (
                  <li key={azienda.id}>
                    {azienda.nome}
                  </li>
                ))}
            </ol>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAziendeDialogOpen(false)}>Chiudi</Button>
          </DialogActions>
        </Dialog>

        <Grid container spacing={2} justifyContent="center" alignItems="center" mt={2}>

          {/* Selettore Azienda */}
          {op && (
            <Grid item xs={12} sm={3} textAlign="center">
              <Autocomplete
                id="azienda-autocomplete"
                value={selectedAzienda}
                onChange={(event, newValue) => {
                  setSelectedAzienda(newValue);
                  setSelectedEmployee(TUTTI_DIP); // Reset selezione dipendente
                }}
                options={aziende.map((az) => az.id)}
                getOptionLabel={(id) => {
                  const a = aziende.find(az => az.id === id);
                  return a ? `${a.nome} (${a.id})` : '';
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Azienda"
                    variant="outlined"
                  />
                )}
                fullWidth
              />
            </Grid>
          )}

          {/* Selettore Anno */}
          <Grid item xs={12} sm={2} textAlign="center">
            <Select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              fullWidth
            >
              {Array.from({ length: new Date().getFullYear() - 2023 }, (_, i) => 2025 + i).map((year) => (
                <MenuItem key={year} value={year}>{year}</MenuItem>
              ))}
            </Select>
          </Grid>

          {/* Selettore Mese */}
          <Grid item xs={12} sm={2} textAlign="center">
            <Select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              fullWidth
            >
              {Array.from({ length: 12 }, (_, i) => i).map((month) => {
                const monthName = new Date(0, month).toLocaleString('default', { month: 'long' });
                const capitalizedMonthName = monthName.charAt(0).toUpperCase() + monthName.slice(1);
                return (
                  <MenuItem key={month} value={month}>
                    {capitalizedMonthName}
                  </MenuItem>
                );
              })}
            </Select>
          </Grid>

          {/* Selettore Dipendente*/}
          <Grid item xs={12} sm={3} textAlign="center">
            <Select
              value={selectedEmployee.id}
              onChange={(event) => setSelectedEmployee(employees.filter(e => e.id == event.target.value)[0])}
              fullWidth
            >
              {employees.map((employee) => (
                <MenuItem key={employee.id} value={employee.id}>{employee.cognome} {employee.nome}</MenuItem>
              ))}
            </Select>
          </Grid>

          {/* Icone Eventi e Calendario */}
          <Grid item xs={12} sm={2.5} textAlign="center">
            <Tooltip title={disabledEventi ? "Richiedi la funzionalità Eventi" : "Eventi"}>
              <span>
                <IconButton disabled={disabledEventi} color="primary" onClick={() => handleDialog("eventDialog", true)}>
                  <Badge badgeContent={eventHistory.filter(event => event.approvato === null).length} color="error">
                    <Event fontSize="inherit" style={{ fontSize: 40 }} />
                  </Badge>
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title={disabledEventi ? "Richiedi la funzionalità Comunicazioni" : "Comunicazioni"}>
              <span>
                <IconButton disabled={disabledEventi} color="primary" onClick={() => handleDialog("communicationDialog", true)}>
                  <Badge badgeContent={communicationHistory.filter(event => event.approvato === null).length} color="error">
                    <Email fontSize="inherit" style={{ fontSize: 40 }} />
                  </Badge>
                </IconButton>
              </span>
            </Tooltip>

            <Tooltip title="Timbrature">
              <IconButton color="primary" onClick={() => handleDialog("timbratureDialog", true)}>
                <Badge badgeContent={timbratureHistory.filter(timb => timb.approvata === null).length} color="error">
                  <AccessTime fontSize="large" />
                </Badge>
              </IconButton>
            </Tooltip>
            <Tooltip title="Calendario">
              <IconButton color="primary" onClick={handleCalendarDialog}>
                <CalendarMonth fontSize="large" />
              </IconButton>
            </Tooltip>
          </Grid>

          {/* Icone Profilo Orario e Approvazione Ore e link */}
          <Grid item xs={12} sm={2.5} textAlign="center">
            <Tooltip title="Profilo Orario">
              <IconButton disabled={!selectedEmployee.id} color={savedIcons.setHours ? "success" : "primary"}
                onClick={() => { handleDialog("setHours", true); setSelectedTemplate('') }}>
                <Timer fontSize="large" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Approva Ore">
              <IconButton disabled={selectedEmployee.id} color={savedIcons.approveHours ? "success" : "primary"} onClick={handleConfirmApproveOpen}>
                <CheckCircleOutline fontSize="large" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Apri Presenze">
              <IconButton color="primary" onClick={() => navigate(op ? '../op/paghe/presenze' : '../cli/presenze')}>
                <EmojiPeople fontSize="large" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Dipendenti">
              <IconButton color="primary" onClick={() => navigate(`../${op ? 'op/paghe' : 'cli'}/dipendenti`)}>
                <People fontSize="large" />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>

        {/* Conferma Approvazione Ore */}
        <Dialog
          open={confirmApproveDialogOpen}
          onClose={handleConfirmApproveClose}
        >
          <DialogTitle>Conferma Approvazione</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Sei sicuro di voler approvare le ore? Questaget azione non può essere annullata.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleConfirmApproveClose} color="primary">
              Annulla
            </Button>
            <Button onClick={handleConfirmApprove} color="primary" variant="contained">
              Conferma
            </Button>
          </DialogActions>
        </Dialog>

        {/* Tabella Generale Giorni Mese */}
        <Grid item xs={12} mt={2}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ backgroundColor: (theme) => theme.palette.grey[900], color: 'white' }}>
                <TableRow>
                  <TableCell align="center"><Typography variant="body1" fontWeight="bold" color="white">Data</Typography></TableCell>
                  <TableCell align="center"><Typography variant="body1" fontWeight="bold" color="white">Entrata</Typography></TableCell>
                  <TableCell align="center"><Typography variant="body1" fontWeight="bold" color="white">Pause</Typography></TableCell>
                  <TableCell align="center"><Typography variant="body1" fontWeight="bold" color="white">Uscita</Typography></TableCell>
                  <TableCell align="center"><Typography variant="body1" fontWeight="bold" color="white">Straord</Typography></TableCell>
                  <TableCell align="center"><Typography variant="body1" fontWeight="bold" color="white">Totale Ore</Typography></TableCell>
                  <TableCell align="center"><Typography variant="body1" fontWeight="bold" color="white">Eventi</Typography></TableCell>
                  <TableCell align="center"><Typography variant="body1" fontWeight="bold" color="white">Mappa</Typography></TableCell>
                  <TableCell align="center"><Typography variant="body1" fontWeight="bold" color="white">Note</Typography></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {daysInMonth.map((day) => {
                  const timbratura = getTimbratureForDay(day);
                  const eventsForDay = getEventsForDay(day);
                  return (
                    <TableRow
                      key={day.toISOString()}
                      sx={{
                        backgroundColor: day.getDay() === 0 || day.getDay() === 6 ? 'rgba(255, 255, 0, 0.19)' :
                          getFestivoInfo(day.getFullYear(), day.getMonth(), day.getDate()) ? 'rgba(173, 216, 230, 0.21)' : 'transparent',
                        animation: timbratura?.inCorso ? `${lampeggioVerde} 1.5s infinite` : 'none'
                      }}
                    >
                      <TableCell align="center">
                        <div style={{ textAlign: 'center' }}>
                          {getFestivoInfo(day.getFullYear(), day.getMonth(), day.getDate()) && (
                            <Typography variant="caption" color="textSecondary" style={{ fontStyle: 'italic', display: 'block', marginBottom: '4px' }}>
                              {getFestivoInfo(day.getFullYear(), day.getMonth(), day.getDate()).nome}
                            </Typography>
                          )}
                          {formatDate(day)}
                        </div>
                      </TableCell>
                      <TableCell align="center">
                        {timbratura?.inCorso ? <span>
                          {ts2Time(timbratura.entrata.t)}
                        </span> : <span onClick={() => { setEditingTimbratura(timbratura); handleDialog("entrataMod", true) }} style={{ cursor: "pointer" }}>
                          {ts2Time(timbratura.entrata.t)}
                        </span>}
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="Dettaglio">
                          {timbratura?.inCorso ?
                            <Typography display="inline">
                              {utils.min2hours(calculateTotalPause(timbratura.pause)) || ""}
                            </Typography> :
                            <Typography
                              display="inline"
                              style={{ cursor: "pointer" }}
                              onClick={() => { setEditingTimbratura(timbratura); handleDialog("pauseDetails", true) }}
                            >
                              {utils.min2hours(calculateTotalPause(timbratura.pause)) || ""}
                            </Typography>}
                        </Tooltip>
                      </TableCell>

                      <TableCell align="center">
                        <span onClick={() => { setEditingTimbratura(timbratura); handleDialog("uscitaMod", true) }} style={{ cursor: "pointer" }}>
                          {ts2Time(timbratura.uscita?.t)}
                        </span>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body1" fontWeight="bold">
                          {timbratura.totMinStra ? utils.min2hours(timbratura.totMinStra) : ""}
                        </Typography>
                      </TableCell>

                      <TableCell align="center">
                        <Typography variant="body1" fontWeight="bold">
                          {timbratura.totMinOrd ? utils.min2hours(timbratura.totMinOrd) : ""}
                        </Typography>
                      </TableCell>

                      <TableCell align="center">
                        {selectedEmployee.id !== 0 && eventsForDay.length > 0 && (
                          <Tooltip title={eventsForDay[0].tipo}>
                            <IconButton>
                              <Typography
                                variant="caption"
                                style={{
                                  borderRadius: '12px',
                                  padding: '2px 6px',
                                  display: 'inline-block',
                                  fontSize: '0.75rem',
                                  textAlign: 'center',
                                  ...getEventColor(eventsForDay[0]),
                                }}
                              >
                                {eventsForDay[0].tipo}
                              </Typography>
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>

                      <TableCell align="center">
                        <IconButton onClick={() => { setEditingTimbratura(timbratura); handleDialog("map", true) }}>
                          <Map fontSize="small" />
                        </IconButton>
                      </TableCell>

                      <TableCell align="center">
                        <IconButton disabled={!timbratura.entrata.t} onClick={() => { setEditingTimbratura(timbratura); handleDialog("notes", true) }}>
                          <Note fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
                <TableRow sx={{ backgroundColor: 'rgba(0, 0, 0, 0.05)', fontWeight: 'bold' }}>
                  <TableCell align="center">
                    <Typography variant="body1" fontWeight="bold">Totale</Typography>
                  </TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center">
                    <Typography variant="body1" fontWeight="bold">{utils.min2hours(calculateTotalPauseForAllDays())}</Typography>
                  </TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center">
                    <Typography variant="body1" fontWeight="bold">{utils.min2hours(calculateTotalStraordinario())}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body1" fontWeight="bold">{utils.min2hours(calculateTotalHours())}</Typography>
                  </TableCell>
                  <TableCell colSpan={2}></TableCell>
                </TableRow>

              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        {renderDialog("eventDialog", (
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Eventi</Typography>
            {selectedEmployee.id !== 0 && (
              <Tooltip title="Aggiungi evento per il dipendente selezionato">
                <IconButton
                  onClick={() => handleDialog("addEventDialog", true)}
                  style={{ color: 'green' }}
                >
                  <Add />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        ), (
          <TableContainer component={Paper} style={{ overflowX: 'auto', borderRadius: '10px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: '#333' }}>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Dipendente</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Tipo</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Data Da</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Data A</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Ora da</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Ora a</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Note</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Documenti</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Approvazione</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {eventHistory.filter(event => selectedEmployee.id || event.approvato === null).map((event) => (
                  <TableRow key={event.id}>
                    <TableCell align="center">{employees.filter(e => e.id == event.dipendente_id).map(e => `${e.cognome} ${e.nome}`)[0] || ''}</TableCell>
                    <TableCell align="center">
                      <Typography
                        variant="caption"
                        style={{
                          borderRadius: '12px',
                          padding: '2px 6px',
                          display: 'inline-block',
                          fontSize: '0.75rem',
                          textAlign: 'center',
                          ...getEventColor(event),
                        }}
                      >
                        {event.tipo}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">{utils.revDate(event.payload.dateFrom)}</TableCell>
                    <TableCell align="center">{utils.revDate(event.payload.dateTo)}</TableCell>
                    <TableCell align="center">{ts2Time(event.payload.timeFrom)}</TableCell>
                    <TableCell align="center">{ts2Time(event.payload.timeTo)}</TableCell>
                    <TableCell align="center">
                      <IconButton disabled={!event.payload.note} onClick={() => { setEditingTimbratura({ ...dummyTimbratura, ...event.payload }); handleDialog("notesEvent", true) }}>
                        <Note fontSize="small" />
                      </IconButton>
                    </TableCell>
                    <TableCell align="center">
                      {event.payload.file ? (
                        <>
                          <Tooltip title="Visualizza">
                            <IconButton disabled={!event.payload.file.name.endsWith('.pdf')} onClick={() => utils.cliOpenPdfInNewTab(event.payload.file.id)} color="primary">
                              <Visibility />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Scarica">
                            <IconButton color="success" onClick={() => utils.cliDownload(event.payload.file.id)}>
                              <Download />
                            </IconButton>
                          </Tooltip>
                        </>) : <div />}
                    </TableCell>
                    <TableCell align="center">
                      {event.approvato && <CheckCircleOutline style={{ color: 'green' }} />}
                      {event.approvato === false && <Cancel style={{ color: 'red' }} />}
                      {event.approvato === null && (
                        <>
                          <IconButton onClick={() => handleEventApproval(event.id, true)}>
                            <CheckCircleOutline style={{ color: 'green' }} />
                          </IconButton>
                          <IconButton onClick={() => handleEventApproval(event.id, false)}>
                            <Cancel style={{ color: 'red' }} />
                          </IconButton>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ), false)}

        {/* Dialogo Aggiungi Evento */}
        {renderDialog("addEventDialog", (
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Aggiungi Evento</Typography>
            <Chip
              label="Resetta"
              onClick={() => setNewEventData({})}
              sx={{ cursor: 'pointer' }}
            />
          </Box>
        ), (
          <Box>
            <Typography variant="caption" fontStyle="italic" color="red" component="div" sx={{ marginBottom: '16px' }}>
              Inserire "Ora da" e "Ora a" solo nel caso in cui l'evento avviene all'interno di uno stesso turno lavorativo
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={2.4}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel>Evento</InputLabel>
                  <Select
                    required
                    value={newEventData?.type || ""}
                    onChange={(e) => handleNewEventChange("type", e.target.value)}
                    label="Evento"
                  >
                    {["Ferie", "Permesso", "Assenza", "Altro"].map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <DatePicker
                  label="Data Da"
                  value={newEventData?.dateFrom || null}
                  onChange={(date) => handleNewEventChange("dateFrom", date)}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <DatePicker
                  label="Data A"
                  value={newEventData?.dateTo || null}
                  onChange={(date) => handleNewEventChange("dateTo", date)}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <TimePicker
                  label="Ora da"
                  value={newEventData?.timeFrom || null}
                  onChange={(time) => handleNewEventChange("timeFrom", time)}
                  renderInput={(params) => <TextField {...params} fullWidth inputProps={{ style: { overflow: 'hidden' } }} />}
                  ampm={false}
                />
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <TimePicker
                  label="Ora a"
                  value={newEventData?.timeTo || null}
                  onChange={(time) => handleNewEventChange("timeTo", time)}
                  renderInput={(params) => <TextField {...params} fullWidth inputProps={{ style: { overflow: 'hidden' } }} />}
                  ampm={false}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Note"
                  multiline
                  rows={3}
                  fullWidth
                  value={newEventData?.note || ""}
                  onChange={(e) => handleNewEventChange("note", e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" alignItems="center" justifyContent="flex-start" mb={1}>
                  <Typography variant="body1" fontWeight="bold" gutterBottom style={{ margin: '8px', color: 'gray' }}>
                    File
                  </Typography>
                  <Tooltip title="Carica Documenti">
                    <IconButton component="label" color="primary">
                      <Upload />
                      <input
                        type="file"
                        hidden
                        multiple
                        onChange={(event) => {
                          const files = Array.from(event.target.files);
                          if (files.length > 0) {
                            handleNewEventChange("files", [...(newEventData?.files || []), ...files]);
                          }
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>
                <TableContainer component={Paper} style={{ borderRadius: '10px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
                  <Table>
                    <TableHead>
                      <TableRow style={{ backgroundColor: '#333' }}>
                        <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Nome File</TableCell>
                        <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Data Inserimento</TableCell>
                        <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Azioni</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {newEventData?.files?.map((file, index) => (
                        <TableRow key={index}>
                          <TableCell style={{ width: '33.33%', textAlign: 'center' }}>{file.name}</TableCell>
                          <TableCell style={{ width: '33.33%', textAlign: 'center' }}>{new Date(file.lastModified).toLocaleDateString()}</TableCell>
                          <TableCell style={{ width: '33.33%', textAlign: 'center' }}>
                            <Tooltip title="Elimina">
                              <IconButton
                                onClick={() => {
                                  const updatedFiles = newEventData?.files?.filter((_, i) => i !== index);
                                  handleNewEventChange("files", updatedFiles);
                                }}
                                color="error"
                              >
                                <Delete />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                      {!newEventData?.files?.length && (
                        <TableRow>
                          <TableCell colSpan={3} align="center" style={{ textAlign: 'center' }}>
                            Nessun file caricato.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Box>
        ), true, 'md')}

        {renderDialog("communicationDialog", (
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Comunicazioni</Typography>
            {selectedEmployee.id !== 0 && (
              <Tooltip title="Aggiungi comunicazione per il dipendente selezionato">
                <IconButton
                  onClick={() => handleDialog("addCommunicationDialog", true)}
                  style={{ color: 'green' }}
                >
                  <Add />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        ), (
          <TableContainer component={Paper} style={{ overflowX: 'auto', borderRadius: '10px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: '#333' }}>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Dipendente</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Tipo</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Data Da</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Data A</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Ora da</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Ora a</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Note</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Documenti</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {communicationHistory.filter(comm => selectedEmployee.id || !comm.visualizzata).map((comm) => (
                  <TableRow key={comm.id}>
                    <TableCell align="center">{employees.filter(e => e.id == comm.dipendente_id).map(e => `${e.cognome} ${e.nome}`)[0] || ''}</TableCell>
                    <TableCell align="center">
                      <Typography
                        variant="caption"
                        style={{
                          borderRadius: '12px',
                          padding: '2px 6px',
                          display: 'inline-block',
                          fontSize: '0.75rem',
                          textAlign: 'center',
                          backgroundColor: getColorByType(comm.tipo), // Colore pieno
                          color: 'white' // Testo bianco
                        }}
                      >
                        {comm.tipo}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">{utils.revDate(comm.payload.dateFrom)}</TableCell>
                    <TableCell align="center">{utils.revDate(comm.payload.dateTo)}</TableCell>
                    <TableCell align="center">{ts2Time(comm.payload.timeFrom)}</TableCell>
                    <TableCell align="center">{ts2Time(comm.payload.timeTo)}</TableCell>
                    <TableCell align="center">
                      <IconButton disabled={!comm.payload.note} onClick={() => { setEditingTimbratura({ ...dummyTimbratura, ...comm.payload }); handleDialog("notesCommunication", true) }}>
                        <Note fontSize="small" />
                      </IconButton>
                    </TableCell>
                    <TableCell align="center">
                      {comm.payload.file ? (
                        <>
                          <Tooltip title="Visualizza">
                            <IconButton disabled={!comm.payload.file.name.endsWith('.pdf')} onClick={() => utils.cliOpenPdfInNewTab(comm.payload.file.id)} color="primary">
                              <Visibility />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Scarica">
                            <IconButton color="success" onClick={() => utils.cliDownload(comm.payload.file.id)}>
                              <Download />
                            </IconButton>
                          </Tooltip>
                        </>) : <div />}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ), false)}

        {/* Dialogo Aggiungi Comunicazione */}
        {renderDialog("addCommunicationDialog", (
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Aggiungi Comunicazione</Typography>
            <Chip
              label="Resetta"
              onClick={() => setNewCommunicationData({})}
              sx={{ cursor: 'pointer' }}
            />
          </Box>
        ), (
          <Box>
            <Typography variant="caption" fontStyle="italic" color="red" component="div" sx={{ marginBottom: '16px' }}>
              Inserire "Ora da" e "Ora a" solo nel caso in cui la comunicazione avvenga all'interno di uno stesso turno lavorativo
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={2.4}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel>Comunicazione</InputLabel>
                  <Select
                    required
                    value={newCommunicationData?.type || ""}
                    onChange={(e) => handleNewCommunicationChange("type", e.target.value)}
                    label="Comunicazione"
                  >
                    {["Malattia", "Infortunio", "Maternità", "Congedo", "Donazione Sangue", "Altro"].map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <DatePicker
                  label="Data Da"
                  value={newCommunicationData?.dateFrom || null}
                  onChange={(date) => handleNewCommunicationChange("dateFrom", date)}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <DatePicker
                  label="Data A"
                  value={newCommunicationData?.dateTo || null}
                  onChange={(date) => handleNewCommunicationChange("dateTo", date)}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <TimePicker
                  label="Ora da"
                  value={newCommunicationData?.timeFrom || null}
                  onChange={(time) => handleNewCommunicationChange("timeFrom", time)}
                  renderInput={(params) => <TextField {...params} fullWidth inputProps={{ style: { overflow: 'hidden' } }} />}
                  ampm={false}
                />
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <TimePicker
                  label="Ora a"
                  value={newCommunicationData?.timeTo || null}
                  onChange={(time) => handleNewCommunicationChange("timeTo", time)}
                  renderInput={(params) => <TextField {...params} fullWidth inputProps={{ style: { overflow: 'hidden' } }} />}
                  ampm={false}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Note"
                  multiline
                  rows={3}
                  fullWidth
                  value={newCommunicationData?.note || ""}
                  onChange={(e) => handleNewCommunicationChange("note", e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" alignItems="center" justifyContent="flex-start" mb={1}>
                  <Typography variant="body1" fontWeight="bold" gutterBottom style={{ margin: '8px', color: 'gray' }}>
                    File
                  </Typography>
                  <Tooltip title="Carica Documenti">
                    <IconButton component="label" color="primary">
                      <Upload />
                      <input
                        type="file"
                        hidden
                        multiple
                        onChange={(event) => {
                          const files = Array.from(event.target.files);
                          if (files.length > 0) {
                            handleNewCommunicationChange("files", [...(newCommunicationData?.files || []), ...files]);
                          }
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>
                <TableContainer component={Paper} style={{ borderRadius: '10px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
                  <Table>
                    <TableHead>
                      <TableRow style={{ backgroundColor: '#333' }}>
                        <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Nome File</TableCell>
                        <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Data Inserimento</TableCell>
                        <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Azioni</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {newCommunicationData?.files?.map((file, index) => (
                        <TableRow key={index}>
                          <TableCell style={{ width: '33.33%', textAlign: 'center' }}>{file.name}</TableCell>
                          <TableCell style={{ width: '33.33%', textAlign: 'center' }}>{new Date(file.lastModified).toLocaleDateString()}</TableCell>
                          <TableCell style={{ width: '33.33%', textAlign: 'center' }}>
                            <Tooltip title="Elimina">
                              <IconButton
                                onClick={() => {
                                  const updatedFiles = newCommunicationData?.files?.filter((_, i) => i !== index);
                                  handleNewCommunicationChange("files", updatedFiles);
                                }}
                                color="error"
                              >
                                <Delete />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                      {!newCommunicationData?.files?.length && (
                        <TableRow>
                          <TableCell colSpan={3} align="center" style={{ textAlign: 'center' }}>
                            Nessun file caricato.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Box>
        ), true, 'md')}

        {/* Dialog Aggiungi Timbratura */}
        <Dialog
          open={dialogs.addTimbraturaDialog}
          onClose={() => handleDialog("addTimbraturaDialog", false)}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>
            Aggiungi Timbratura
            <Chip
              label="Resetta"
              onClick={() => setNewTimbraturaData({})}
              sx={{ cursor: 'pointer', marginLeft: '16px' }}
            />
          </DialogTitle>
          <DialogContent>
            <Box component="form" sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={2.4}>
                  <DatePicker
                    label="Data"
                    value={newTimbraturaData?.date || null}
                    onChange={(date) => handleNewTimbraturaChange("date", date)}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                  />
                </Grid>
                <Grid item xs={12} sm={2.4}>
                  <TimePicker
                    label="Entrata"
                    value={newTimbraturaData?.entrata || null}
                    onChange={(time) => handleNewTimbraturaChange("entrata", time)}
                    renderInput={(params) => <TextField {...params} fullWidth inputProps={{ style: { overflow: 'hidden' } }} />}
                    ampm={false}
                  />
                </Grid>
                {/* Campi Pausa e Rientro Dinamici */}
                {(newTimbraturaData.pauses || []).map((_, index) => (
                  <React.Fragment key={index}>
                    <Grid item xs={12} sm={2.4}>
                      <TimePicker
                        label={`Pausa ${index + 1}`}
                        value={newTimbraturaData.pauses[index] || null}
                        onChange={(time) => {
                          const updatedPauses = [...newTimbraturaData.pauses];
                          updatedPauses[index] = time;
                          handleNewTimbraturaChange('pauses', updatedPauses);
                        }}
                        renderInput={(params) => <TextField {...params} fullWidth inputProps={{ style: { overflow: 'hidden' } }} />}
                        ampm={false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={2.4}>
                      <TimePicker
                        label={`Rientro ${index + 1}`}
                        value={newTimbraturaData.rientri[index] || null}
                        onChange={(time) => {
                          const updatedRientri = [...newTimbraturaData.rientri];
                          updatedRientri[index] = time;
                          handleNewTimbraturaChange('rientri', updatedRientri);
                        }}
                        renderInput={(params) => <TextField {...params} fullWidth inputProps={{ style: { overflow: 'hidden' } }} />}
                        ampm={false}
                      />
                    </Grid>
                  </React.Fragment>
                ))}
                <Grid item xs={12} sm={2.4}>
                  <TimePicker
                    label="Uscita"
                    value={newTimbraturaData?.uscita || null}
                    onChange={(time) => handleNewTimbraturaChange("uscita", time)}
                    renderInput={(params) => <TextField {...params} fullWidth inputProps={{ style: { overflow: 'hidden' } }} />}
                    ampm={false}
                  />
                </Grid>
                <Grid item xs={12} sm={2.4} textAlign="center" alignSelf="center">
                  <Typography
                    variant="caption"
                    style={{ color: 'gray', fontStyle: 'italic', display: 'block', marginBottom: '0px' }}
                  >
                    Aggiungi Pause
                  </Typography>
                  <IconButton
                    onClick={() => {
                      const currentPauses = newTimbraturaData.pauses || [];
                      if (currentPauses.length < 3) {
                        handleNewTimbraturaChange("pauses", [...currentPauses, null]);
                        handleNewTimbraturaChange("rientri", [...(newTimbraturaData.rientri || []), null]);
                      }
                    }}
                  >
                    <AddCircle />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      handleNewTimbraturaChange("pauses", (newTimbraturaData.pauses || []).slice(0, -1));
                      handleNewTimbraturaChange("rientri", (newTimbraturaData.rientri || []).slice(0, -1));
                    }}
                    disabled={!(newTimbraturaData.pauses?.length > 0)}
                  >
                    <RemoveCircle />
                  </IconButton>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Note"
                    multiline
                    rows={3}
                    fullWidth
                    value={newTimbraturaData?.note || ""}
                    onChange={(e) => handleNewTimbraturaChange("note", e.target.value)}
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleDialog("addTimbraturaDialog", false)}>Annulla</Button>
            <Button onClick={handleSaveNewTimbraturaRequest} variant="contained">Invia</Button>
          </DialogActions>
        </Dialog>

        {renderDialog("timbratureDialog", (
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Richieste di Timbratura</Typography>
            {selectedEmployee.id !== 0 && (
              <Tooltip title="Aggiungi timbratura per il dipendente selezionato">
                <IconButton
                  onClick={() => handleDialog("addTimbraturaDialog", true)}
                  style={{ color: 'green' }}
                >
                  <Add />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        ), (
          <TableContainer component={Paper} style={{ overflowX: 'auto', borderRadius: '10px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: '#333' }}>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Dipendente</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Data</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Entrata</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Totale Pause</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Uscita</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Note</TableCell>
                  <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Approvazione</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {timbratureHistory.filter(timbratura => selectedEmployee.id || timbratura.approvata === null).map((timbratura) => (
                  <TableRow key={timbratura.id}>
                    <TableCell align="center">{employees.filter(e => e.id == timbratura.dipendente_id).map(e => `${e.cognome} ${e.nome}`)[0] || ''}</TableCell>
                    <TableCell align="center">{formatDate(new Date(timbratura.id))}</TableCell>
                    <TableCell align="center">{ts2Time(timbratura.entrata.t)}</TableCell>
                    <TableCell align="center">{utils.min2hours(calculateTotalPause(timbratura.pause))}</TableCell>
                    <TableCell align="center">{ts2Time(timbratura.uscita?.t)}</TableCell>
                    <TableCell align="center">
                      <IconButton onClick={() => { setEditingTimbratura(timbratura); handleDialog("notesHistory", true) }}>
                        <Note fontSize="small" />
                      </IconButton>
                    </TableCell>
                    <TableCell align="center">
                      {timbratura.approvata && <CheckCircleOutline style={{ color: 'green' }} />}
                      {timbratura.approvata === false && <Cancel style={{ color: 'red' }} />}
                      {timbratura.approvata === null && (
                        <>
                          <IconButton onClick={() => handleTimbraturaApproval(timbratura.dipendente_id, timbratura.id, true)}>
                            <CheckCircleOutline style={{ color: 'green' }} />
                          </IconButton>
                          <IconButton onClick={() => handleTimbraturaApproval(timbratura.dipendente_id, timbratura.id, false)}>
                            <Cancel style={{ color: 'red' }} />
                          </IconButton>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ), false)}

        {renderCalendarDialog()}
        {renderEventDetailDialog()}

        {renderDialog(
          "setHours",
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Imposta Orario</Typography>
            <Tooltip title="Guida Profilo Orario">
              <IconButton onClick={() => handleDialog("toleranceInfo", true)}>
                <InfoOutlined />
              </IconButton>
            </Tooltip>
          </Box>,
          <Box>
            <Typography variant="caption" fontWeight="bold" sx={{ marginBottom: 2, display: 'block' }}>
              Seleziona o Aggiungi Template Orario
            </Typography>
            <Grid container spacing={2} alignItems="center" mb={2}>
              <Grid item xs={12} sm={3} textAlign="center">
                <Select
                  value={selectedTemplate}
                  onChange={(e) => {
                    setSelectedTemplate(e.target.value);
                    handleTemplateChange(e.target.value);
                  }}
                  fullWidth
                >
                  {templates.map((template) => (
                    <MenuItem key={template.id} value={template.id}>
                      {template.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={12} sm={3} textAlign="center">
                <Tooltip title="Crea un nuovo template con questo orario">
                  <IconButton color="primary" onClick={handleAddTemplate}>
                    <AddCircleOutline fontSize="medium" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Aggiorna il template selezionato con questo orario">
                  <IconButton color="secondary" disabled={!selectedTemplate} onClick={handleUpdateTemplate}>
                    <SystemUpdateAlt fontSize="medium" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Elimina il template selezionato">
                  <IconButton color="error" disabled={!selectedTemplate} onClick={handleDeleteTemplate}>
                    <DeleteOutline fontSize="medium" />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={3} textAlign="center">
                <FormControlLabel
                  control={
                    <Switch
                      checked={selectedEmployee.orario.auto || false}
                      onChange={(e) => setSelectedEmployee(prevEmployee => {
                        return {
                          ...prevEmployee, orario: {
                            ...prevEmployee.orario, auto: e.target.checked
                          }
                        }
                      })}
                      color="primary"
                    />
                  }
                  label="Timbra Solo Presenza"
                />
              </Grid>
            </Grid>

            <Typography variant="caption" fontWeight="bold" sx={{ marginBottom: 2, display: 'block' }}>
              Imposta la Tolleranza dei Minuti per Eccesso o Difetto
            </Typography>
            <Grid container spacing={2} mb={2}>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel>Tolleranza Min Ordinari</InputLabel>
                  <Select
                    value={Math.abs(selectedEmployee.orario.tolleranze.ordinario)}
                    onChange={(e) => setSelectedEmployee(prevEmployee => {
                      return {
                        ...prevEmployee, orario: {
                          ...prevEmployee.orario, tolleranze: {
                            ...prevEmployee.orario.tolleranze,
                            ordinario: Number(e.target.value) * (prevEmployee.orario.tolleranze.ordinario >= 0 ? 1 : -1)
                          }
                        }
                      }
                    })}
                    label="Tolleranza Min Ordinari"
                  >
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel>Verso</InputLabel>
                  <Select
                    value={selectedEmployee.orario.tolleranze.ordinario >= 0 ? "Eccesso" : "Difetto"}
                    onChange={(e) => setSelectedEmployee(prevEmployee => {
                      console.log(selectedEmployee)
                      console.log(prevEmployee)
                      return {
                        ...prevEmployee, orario: {
                          ...prevEmployee.orario, tolleranze: {
                            ...prevEmployee.orario.tolleranze,
                            ordinario: (e.target.value == "Difetto" ? -1 : 1) * Math.abs(prevEmployee.orario.tolleranze.ordinario)
                          }
                        }
                      }
                    })}

                    label="Verso"
                  >
                    <MenuItem value="Eccesso">Eccesso</MenuItem>
                    <MenuItem value="Difetto">Difetto</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel>Tolleranza Min Straordinari</InputLabel>
                  <Select
                    value={Math.abs(selectedEmployee.orario.tolleranze.straordinario)}
                    onChange={(e) => setSelectedEmployee(prevEmployee => {
                      return {
                        ...prevEmployee, orario: {
                          ...prevEmployee.orario, tolleranze: {
                            ...prevEmployee.orario.tolleranze,
                            straordinario: Number(e.target.value) * (prevEmployee.orario.tolleranze.straordinario >= 0 ? 1 : -1)
                          }
                        }
                      }
                    })}
                    label="Tolleranza Ore Straordinari"
                  >
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel>Verso</InputLabel>
                  <Select
                    value={selectedEmployee.orario.tolleranze.straordinario >= 0 ? "Eccesso" : "Difetto"}
                    onChange={(e) => setSelectedEmployee(prevEmployee => {
                      return {
                        ...prevEmployee, orario: {
                          ...prevEmployee.orario, tolleranze: {
                            ...prevEmployee.orario.tolleranze,
                            straordinario: (e.target.value == "Difetto" ? -1 : 1) * Math.abs(prevEmployee.orario.tolleranze.straordinario)
                          }
                        }
                      }
                    })}
                    label="Verso"
                  >
                    <MenuItem value="Eccesso">Eccesso</MenuItem>
                    <MenuItem value="Difetto">Difetto</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Typography variant="caption" fontWeight="bold" sx={{ marginBottom: 2, display: 'block' }}>
              Imposta le Ore per ogni Giorno
            </Typography>
            <Grid container spacing={2} alignItems="center">
              {['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'].map((day, idx) => (
                <Grid item xs={12} md key={day}>
                  <TimePicker
                    label={day}
                    value={dayjs(selectedEmployee?.orario?.giorni?.[idx] || "00:00", "HH:mm")}
                    onChange={(time) => setSelectedEmployee(prevEmployee => {
                      const giorni = prevEmployee.orario.giorni;
                      const formattedTime = time ? time.format('HH:mm') : "00:00";
                      giorni[idx] = formattedTime;
                      return {
                        ...prevEmployee, orario: {
                          ...prevEmployee.orario, giorni
                        }
                      }
                    })}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                    ampm={false}
                  />
                </Grid>
              ))}
              <Grid item xs={12} md>
                <TextField
                  label="Totale Ore"
                  type="text"
                  fullWidth
                  value={calculateWeeklyTotal()} // Usa la funzione per calcolare il totale
                  InputProps={{
                    readOnly: true,
                    style: { fontWeight: 'bold' }
                  }}
                />
              </Grid>
            </Grid>

            <Typography variant="caption" fontWeight="bold" sx={{ marginTop: 2, display: 'block' }}>
              Scrivi Eventuali Note
            </Typography>
            <Grid item xs={12} mt={2}>
              <TextField
                label="Note"
                value={selectedEmployee.orario.note}
                onChange={(e) => setSelectedEmployee(prevEmployee => {
                  return {
                    ...prevEmployee, orario: {
                      ...prevEmployee.orario, note: e.target.value
                    }
                  }
                })}
                fullWidth
                multiline
                rows={3}
              />
            </Grid>

            {/* Conferma Salva Profilo Orario Per Tutti */}
            <DialogActions>
              <Tooltip title="Salva questo profilo orario per tutti i dipendenti">
                <span>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleConfirmSaveOpen} // Mostra il dialog
                  >
                    Salva per Tutti i Dipendenti
                  </Button>
                </span>
              </Tooltip>
            </DialogActions>

            <Dialog
              open={confirmSaveDialogOpen}
              onClose={handleConfirmSaveClose}
            >
              <DialogTitle>Conferma Salvataggio</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Sei sicuro di voler salvare questo profilo orario per <b>tutti i dipendenti</b>?<br />
                  Questa azione non può essere annullata.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleConfirmSaveClose} color="primary">
                  Annulla
                </Button>
                <Button onClick={() => saveOrario(true)} color="primary" variant="contained">
                  Conferma
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        )}

        {/* Aggiungi nuovo Template Profilo Orario */}
        <Dialog open={addTemplateDialogOpen} onClose={handleCloseTemplateDialog}>
          <DialogTitle>Aggiungi Nuovo Template Orario</DialogTitle>
          <DialogContent>
            <TextField
              label="Titolo Template"
              value={newTemplateTitle}
              onChange={(e) => setNewTemplateTitle(e.target.value)}
              fullWidth
              sx={{ mt: 1 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseTemplateDialog} color="primary">
              Annulla
            </Button>
            <Button onClick={handleSaveTemplate} color="primary" variant="contained">
              Salva
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog info sulla tolleranza minuti e template orario */}
        {renderDialog(
          "toleranceInfo",
          "Guida Profilo Orario",
          <Box sx={{ p: 1 }}>
            <Typography variant="h6" gutterBottom>
              ✅ Imposta Ore per Giorno
            </Typography>
            <Typography variant="body1" paragraph>
              Inserisci il numero di ore che il dipendente deve lavorare in ciascun giorno.
              Imposta le ore solo nei giorni effettivamente lavorativi per quel dipendente.
              I giorni non lavorativi devono rimanere a zero.
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
              ⏱️ Timbra Solo Presenza
            </Typography>
            <Typography variant="body1" paragraph>
              Se questa opzione è attiva, il dipendente deve timbrare solo l’ingresso.
              Il sistema calcolerà automaticamente le ore lavorate in base all'orario impostato, a partire dall’orario di entrata.
              È utile per semplificare la gestione delle timbrature.
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
              ⌛ Tolleranza sui Minuti di Timbratura
            </Typography>
            <Typography variant="body1" paragraph>
              La tolleranza permette di arrotondare automaticamente le ore lavorate, in base alla differenza tra le timbrature e l’orario previsto.
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>▶️ Tolleranza per Eccesso:</strong> Se un dipendente timbra leggermente prima o esce leggermente dopo rispetto al totale ore impostato, questi minuti extra vengono **aggiunti** al totale giornaliero.
            </Typography>
            <Typography variant="body2" paragraph>
              <u>Esempio:</u> Orario previsto: 8 ore<br />
              Il dipendente timbra dalle 9:00 alle 16:51 → Totale reale: 7h 51m<br />
              Con una tolleranza per eccesso di 10 minuti, il sistema arrotonda a **7h 51m → 8h 00m** (aggiunge 9 min).
              Con una tolleranza per eccesso di 5 minuti, il sistema arrotonda a **7h 51m → 7h 55m** (aggiunge 4 min).
            </Typography>

            <Typography variant="body2" paragraph>
              <strong>◀️ Tolleranza per Difetto:</strong> I minuti in più o in meno vengono **ignorati** o **sottratti**, se non raggiungono la soglia di tolleranza.
            </Typography>
            <Typography variant="body2" paragraph>
              <u>Esempio:</u> Orario previsto: 8 ore<br />
              Il dipendente timbra dalle 9:00 alle 16:59 → Totale reale: 7h 59m<br />
              Con una tolleranza per difetto di 10 minuti, il sistema arrotonda a **7h 59m → 7h 50m** (toglie 9 min).
              Con una tolleranza per difetto di 5 minuti, il sistema arrotonda a **7h 59m → 7h 55m** (toglie 4 min).
            </Typography>

            <Typography variant="body2" paragraph sx={{ mt: 1 }}>
              🔁 La tolleranza si applica **giornalmente**, e aiuta a gestire piccoli scostamenti senza dover intervenire manualmente.
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
              🧩 Template Orario
            </Typography>
            <Typography variant="body1" paragraph>
              I template orari ti permettono di salvare una configurazione di orari giornalieri e riutilizzarla per altri dipendenti.
              In questo modo, puoi applicare facilmente le stesse impostazioni a più persone senza doverle inserire ogni volta.
            </Typography>
          </Box>,
          false,
          "md"
        )}

        {renderDialog("entrataMod", "Modifica Entrata",
          <TimePicker
            label={"Entrata"}
            value={dayjs(ts2Time(editingTimbratura?.entrata.t) || "00:00", "HH:mm")}
            onChange={(time) => setEditingTimbratura(prevTimbratura => {
              const formattedTime = time ? time.format('HH:mm') : "00:00";
              const dateTime = new Date(`${editingTimbratura.id}T${formattedTime}:00`);
              const timestamp = dateTime.getTime();
              return { ...prevTimbratura, entrata: { c: prevTimbratura.entrata.c, t: timestamp } }
            })}
            renderInput={(params) => <TextField {...params} fullWidth />}
            ampm={false}
          />)}

        {renderDialog("uscitaMod", "Modifica Uscita",
          <TimePicker
            label={"Uscita"}
            value={dayjs(ts2Time(editingTimbratura?.uscita?.t) || "00:00", "HH:mm")}
            onChange={(time) => setEditingTimbratura(prevTimbratura => {
              const formattedTime = time ? time.format('HH:mm') : "00:00";
              const dateTime = new Date(`${editingTimbratura.id}T${formattedTime}:00`);
              if (formattedTime < ts2Time(editingTimbratura.entrata.t)) {
                dateTime.setDate(dateTime.getDate() + 1);
              }
              const timestamp = dateTime.getTime();
              return { ...prevTimbratura, uscita: { c: prevTimbratura.uscita?.c, t: timestamp } }
            })}
            renderInput={(params) => <TextField {...params} fullWidth />}
            ampm={false}
          />)}

        {renderDialog("pauseStartMod", "Modifica Inizio Pausa",
          <TimePicker
            label={"Inizio Pausa"}
            value={dayjs(ts2Time(editingTimbratura?.pause[editingPauseIndex]?.da.t) || "00:00", "HH:mm")}
            onChange={(time) => setEditingTimbratura(prevTimbratura => {
              const pausa = prevTimbratura.pause[editingPauseIndex];
              const formattedTime = time ? time.format('HH:mm') : "00:00";
              const dateTime = new Date(`${editingTimbratura.id}T${formattedTime}:00`);
              if (formattedTime < ts2Time(editingTimbratura.entrata.t)) {
                dateTime.setDate(dateTime.getDate() + 1);
              }
              const timestamp = dateTime.getTime();
              pausa.da.t = timestamp;
              return { ...prevTimbratura, pause: [...prevTimbratura.pause.slice(0, editingPauseIndex), pausa, ...prevTimbratura.pause.slice(editingPauseIndex + 1)] }
            })}
            renderInput={(params) => <TextField {...params} fullWidth />}
            ampm={false}
          />,
        )}

        {renderDialog("pauseEndMod", "Modifica Fine Pausa",
          <TimePicker
            label={"Fine Pausa"}
            value={dayjs(ts2Time(editingTimbratura?.pause[editingPauseIndex]?.a?.t) || "00:00", "HH:mm")}
            onChange={(time) => setEditingTimbratura(prevTimbratura => {
              const pausa = prevTimbratura.pause[editingPauseIndex];
              const formattedTime = time ? time.format('HH:mm') : "00:00";
              const dateTime = new Date(`${editingTimbratura.id}T${formattedTime}:00`);
              if (formattedTime < ts2Time(editingTimbratura.entrata.t)) {
                dateTime.setDate(dateTime.getDate() + 1);
              }
              const timestamp = dateTime.getTime();
              pausa.a.t = timestamp;
              return { ...prevTimbratura, pause: [...prevTimbratura.pause.slice(0, editingPauseIndex), pausa, ...prevTimbratura.pause.slice(editingPauseIndex + 1)] }
            })}
            renderInput={(params) => <TextField {...params} fullWidth />}
            ampm={false}
          />)}

        {renderDialog("pauseDetails", "Dettaglio Pause", (
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ backgroundColor: (theme) => theme.palette.grey[900], color: 'white' }}>
                <TableRow>
                  <TableCell align="center"><Typography variant="body1" fontWeight="bold" color="white">Pausa</Typography></TableCell>
                  <TableCell align="center"><Typography variant="body1" fontWeight="bold" color="white">Rientro</Typography></TableCell>
                  <TableCell align="center"><Typography variant="body1" fontWeight="bold" color="white">Totale</Typography></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {editingTimbratura?.pause.map((pause, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">
                      <span onClick={() => { setEditingPauseIndex(index); handleDialog("pauseStartMod", true); }} style={{ cursor: "pointer" }}>
                        {ts2Time(pause.da.t)}
                      </span>
                    </TableCell>
                    <TableCell align="center">
                      <span onClick={() => { setEditingPauseIndex(index); handleDialog("pauseEndMod", true); }} style={{ cursor: "pointer" }}>
                        {ts2Time(pause.a?.t)}
                      </span>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="body1" fontWeight="bold">
                        {utils.min2hours(calculateTotalPause([pause]))}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ), false)}

        {renderDialog("map", "Mappa", (
          <MapContainer
            center={getMarkers(editingTimbratura).length > 0 ? [getMarkers(editingTimbratura)[0].lat, getMarkers(editingTimbratura)[0].lon] : [45.4642, 9.1900]}
            zoom={getMarkers(editingTimbratura).length > 0 ? 13 : 5}
            style={{ height: "400px", width: "100%" }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {getMarkers(editingTimbratura).map((marker, index) => (
              <Marker
                key={index}
                position={[marker.lat, marker.lon]}
                icon={new Icon({ iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41] })}
              >
                <Popup>
                  <div>
                    <strong>{marker.title}</strong>
                    <p>Entrata: {ts2Time(editingTimbratura.entrata.t)}</p>
                    {editingTimbratura.pause.map((pause, idx) => (
                      <React.Fragment key={idx}>
                        <p>Pausa {idx + 1}: {ts2Time(pause.da.t)}</p>
                        <p>Rientro {idx + 1}: {ts2Time(pause.a?.t)}</p>
                      </React.Fragment>
                    ))}
                    <p>Uscita: {ts2Time(editingTimbratura.uscita?.t)}</p>
                    <p>Totale Straordinario: {utils.min2hours(editingTimbratura.totMinStra)}</p>
                    <p>Totale Pause: {utils.min2hours(calculateTotalPause(editingTimbratura.pause))}</p>
                    <p><strong>Totale Ore: {utils.min2hours(editingTimbratura.totMinOrd)}</strong></p>
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        ), false)}

        {renderDialog("notes", "Note",
          <TextField label="Note della Giornata" value={editingTimbratura?.note || ""}
            onChange={(e) => setEditingTimbratura({ ...editingTimbratura, note: e.target.value })} fullWidth multiline rows={12} />, true, "md")}

        {renderDialog("notesHistory", "Note",
          <TextField label="Note Richieste Timbratura" value={editingTimbratura?.note || ""}
            disabled fullWidth multiline rows={5} />, false, "md")}

        {renderDialog("notesEvent", "Note",
          <TextField label="Note Evento" value={editingTimbratura?.note || ""}
            disabled fullWidth multiline rows={5} />, false, "md")}

        {renderDialog("notesCommunication", "Note",
          <TextField label="Note Comunicazioni" value={editingTimbratura?.note || ""}
            disabled fullWidth multiline rows={5} />, false, "md")}

        {/* Snackbar per il Successo (Verde) */}
        {successMessage && (
          <Snackbar
            open={true} // Si apre quando successMessage ha un valore
            autoHideDuration={6000} // Si chiude dopo 6 secondi
            onClose={() => setSuccessMessage('')} // Pulisce lo stato alla chiusura
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} // Posizione opzionale
          >
            {/* Usiamo Alert dentro Snackbar per lo stile */}
            <Alert
              onClose={() => setSuccessMessage('')} // Permette la chiusura manuale tramite la 'X' dell'Alert
              severity="success" // Questo imposta lo stile verde e l'icona
              variant="filled"     // Aspetto con sfondo pieno (alternativa: 'standard', 'outlined')
              sx={{ width: '100%' }} // Assicura che l'Alert riempia la Snackbar
            >
              {successMessage} {/* Mostra il messaggio di successo */}
            </Alert>
          </Snackbar>
        )}

        {/* Snackbar per l'Errore (Rosso - usando Alert per coerenza) */}
        {error && (
          <Snackbar
            open={true}
            autoHideDuration={6000}
            onClose={() => setError('')}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} // Posizione opzionale
          >
            <Alert
              onClose={() => setError('')}
              severity="error" // Questo imposta lo stile rosso
              variant="filled"
              sx={{ width: '100%' }}
            >
              {error}
            </Alert>
          </Snackbar>
        )}

      </LocalizationProvider>

      <Paper elevation={3} style={{ padding: '24px', marginTop: '20px', marginBottom: '20px', borderRadius: '12px' }}>
        <Typography variant="h6" gutterBottom textAlign="center" style={{ marginBottom: '20px' }}>
          Riepilogo Eventi e Comunicazioni
        </Typography>
        <Grid container spacing={3}>
          {/* Sezione Eventi */}
          <Grid item xs={12} md={6}>
            <Box mb={2}>

              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" fontWeight="bold">Ferie:</Typography>
                  <Typography variant="body2">
                    {calcolaSommaOreGiorni(eventHistory.filter(event => event.approvato && event.tipo === 'Ferie'))}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" fontWeight="bold">Permessi:</Typography>
                  <Typography variant="body2">
                    {calcolaSommaOreGiorni(eventHistory.filter(event => event.approvato && event.tipo === 'Permesso'))}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" fontWeight="bold">Assenze:</Typography>
                  <Typography variant="body2">
                    {calcolaSommaOreGiorni(eventHistory.filter(event => event.approvato && event.tipo === 'Assenza'))}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" fontWeight="bold">Altri eventi:</Typography>
                  <Typography variant="body2">
                    {calcolaSommaOreGiorni(eventHistory.filter(event => event.approvato && event.tipo === 'Altro'))}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Sezione Comunicazioni */}
          <Grid item xs={12} md={6}>
            <Box mb={2}>

              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" fontWeight="bold">Malattia:</Typography>
                  <Typography variant="body2">
                    {calcolaSommaOreGiorni(communicationHistory.filter(event => event.tipo === 'Malattia'))}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" fontWeight="bold">Infortunio:</Typography>
                  <Typography variant="body2">
                    {calcolaSommaOreGiorni(communicationHistory.filter(event => event.tipo === 'Infortunio'))}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" fontWeight="bold">Maternità:</Typography>
                  <Typography variant="body2">
                    {calcolaSommaOreGiorni(communicationHistory.filter(event => event.tipo === 'Maternità'))}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" fontWeight="bold">Congedi:</Typography>
                  <Typography variant="body2">
                    {calcolaSommaOreGiorni(communicationHistory.filter(event => event.tipo === 'Congedo'))}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" fontWeight="bold">Donazioni Sangue:</Typography>
                  <Typography variant="body2">
                    {calcolaSommaOreGiorni(communicationHistory.filter(event => event.tipo === 'Donazione Sangue'))}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Paper>

    </Container>
  );
};

export default AreaDipTimbrature;
